const AgendamentoTarefasHome = () =>
  import(/* webpackChunkName: "group-pabx-agendamento" */ '../modules/tarefas/_views/AgendamentoTarefasHome')
const CadastroAgendamentosTarefas = () =>
  import(/* webpackChunkName: "group-pabx-agendamento" */ '../modules/tarefas/_views/CadastroAgendamentosTarefas')
const AtualizarAgendamento = () =>
  import(/* webpackChunkName: "group-pabx-agendamento" */ '../modules/tarefas/_views/AtualizarAgendamento')

import { permissionsPabx } from '../../../utils/permissionsPabx'

export default [
  {
    path: 'agendamento',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: AgendamentoTarefasHome,
    name: 'agendamento',
  },
  {
    path: 'agendamento/criar',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: CadastroAgendamentosTarefas,
    name: 'agendamento/criar',
  },
  {
    path: 'agendamento/atualizar/:_id',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: AtualizarAgendamento,
    name: 'agendamento/atualizar',
    props: true,
  },
]
